module.exports = __webpack_public_path__ + "static/Group 3-d525fcf195e29038485d59ad0fcd196f.png";